module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view-customers/view-customers.component.css
// module id = ./src/app/view-customers/view-customers.component.css
// module chunks = main